export default __webpack_public_path__ + "images/assets/7dba8a2f53375c5296e2c24c160950a5.svg";